module.exports = __webpack_public_path__ + "static/media/stage10.abb086e4.svg";